import { BaseFragmentController } from 'src/app/View/BaseUI/BaseFragmentController';
import { EditStoreAddressFragmentComponent } from './EditStoreAddressFragmentComponent';
import {ExamAfterProcessService} from '../../../../../../Service/ExamAfterProcessService';
import {UserDeliveryAddressDTOInterface} from '../../../../../../DTO/UserDeliveryAddressDTOInterface';
import {PostCodeService} from '../../../../../../Service/PostCodeService';

export class EditStoreAddressFragmentController extends BaseFragmentController {

	// 対となるView
	public combineView: EditStoreAddressFragmentComponent;


	/**
	 * 郵便番号から住所を取得
	 * @param param
	 */
	public async getAddress(param: { view: any; postCode: string }): Promise<{prefecture: string; city: string}> {

		const svc = new PostCodeService(param.view);
		return await svc.getAddress(param.postCode);

	}

	public async validatePrescriptionFaxStoreData(param: {view: any; data: UserDeliveryAddressDTOInterface}): Promise<any> {
		const result = [];
		console.log(param.data);
		for (const key of Object.keys(param.data)) {
			switch (key) {
				case 'storeName':
					if (param.data.storeName === '') {
						result.push({
							message: '店舗名を入力してください'
						});
					}
					break;
				case 'telNumber':
					if (param.data.telNumber === '') {
						result.push({
							message: '電話番号を入力してください'
						});
					} else {
						if (!/^[0-9]+$/.test(param.data.telNumber)) {
							result.push({
								message: '電話番号を半角数字で入力してください'
							});
						}
					}
					break;
				case 'faxNumber':
					if (param.data.faxNumber !== '') {
						if (!/^[0-9]+$/.test(param.data.telNumber)) {
							result.push({
								message: 'FAX番号を半角数字で入力してください'
							});
						}
					}
					break;
				case 'postCode':
					if (param.data.postCode === '') {
						result.push({
							message: '郵便番号を入力してください'
						});
					} else {
						if (!/^[0-9]{7}$/.test(param.data.postCode)) {
							result.push({
								message: '郵便番号を半角数字7桁で入力してください'
							});
						}
					}
					break;
				case 'prefecture':
					if (param.data.prefecture === '') {
						result.push({
							message: '都道府県を選択してください'
						});
					}
					break;
			}
		}

		return result;
	}

}
